import React, { useState, useCallback, useRef } from 'react';
import { makeStyles } from "@material-ui/core/styles"
import { TextField, Input, Checkbox } from '@material-ui/core';
import AdapterDateFns from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import ImageSearchOutlinedIcon from '@material-ui/icons/ImageSearchOutlined';
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { toast } from 'react-toastify';
import { personalinfo } from "../../functions/auth"
import { postGeneral } from "../../functions/general"
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
    container: {
        borderRadius: "18px",
        padding: "25px",
        backgroundColor: "#fff",
        width: "875px",
        margin: "20px 40px",
        "@media (max-width: 770px)": {
            padding: "5%",
            margin: "0",
            width: "90%"
        }
    },

    box: {
        margin: "25px 0px",
    },

    title: {
        fontSize: "17px",
        lineHeight: "60px",
        fontWeight: 600,
        width: "100%",
    },

    star: {
        color: theme.palette.secondary.main,
    },

    input: {

        width: "85%",
        height: "58px",
        padding: "0 25px",
        border: "0px",
        backgroundColor: "#f3f3f3",
        fontSize: "20px",
        marginLeft: "20px",
        borderRadius: "10px",
        outline: "none",
        float: "right",
        fontWeight: 600,
        "@media (max-width: 770px)": {
            float: "left",
            width: "100%",
            marginLeft: "0"
        }

    },

    selection: {
        display: 'flex',
        justifyContent: "flex-start",
        alignItems: "stretch",
        "@media (max-width: 770px)": {
            display: "block"
        }

    },

    selectionTitle: {
        width: "80px",
        fontSize: "17px",
        lineHeight: "60px",
        fontWeight: 600,
        "@media (max-width: 770px)": {
            width: "100%",
        }
    },



    selectionContent: {
        width: "100%",
        marginLeft: "50px",
        padding: "10px 0px",
        display: 'flex',
        flexDirection: "column",
        alignItems: "flex-start",
        "@media (max-width: 770px)": {
            width: "100%",
            margin: "0px",
            padding: "0px",
        },
        "& span": {
            fontWeight: 500
        }

    },
    contentBox: {
        width: "100%"
    },

    inputSelection: {

        width: "72%",
        height: "58px",
        padding: "0 25px",
        border: "0px",
        margin: "5px",
        backgroundColor: "#f3f3f3",
        fontSize: "20px",
        borderRadius: "10px",
        outline: "none",
        float: "right",
        fontWeight: 600,

    },

    imgIcon: {
        float: "right",
        // width: "1px",
        "@media (max-width: 770px)": {
            //width: "10%",
            marginLeft: "0",
            padding: "12px 0px"
        }
    },


    img: {
        float: "right",
        width: "8%",
        "@media (max-width: 770px)": {
            width: "50px",
            marginLeft: "0"
        }
    },
    badge: {
        float: "right",
        "& :hover": {

            cursor: "pointer"



        }
    },

    explain: {

        backgroundColor: "#f3f3f3",
        fontSize: "30px",
        fontWeight: 600,
        width: "84%",
        marginLeft: "45px",
        padding: "0px 5px",
        borderRadius: "10px",
        "@media (max-width: 770px)": {


            width: "98%",
            margin: "0px",


        }

    },
    textInput: {
        width: "100%",
        //float: "right",
        backgroundColor: "#f3f3f3",
        borderRadius: "5px",
        fontSize: "20px",
        "@media (max-width: 770px)": {
            float: "left",
            width: "100%",
        }
    },

    display: {
        display: "none"
    },

    button: {
        margin: theme.spacing(1),
        float: "right",
        color: "white",
        fontSize: "17px",
        fontWeight: 700
    },




}))

const CreateGeneral = () => {
    const history = useHistory();
    const [title, setTitle] = useState("");
    const [multiResponse, setMultiResponse] = useState(false);
    const [bitarray, setBitarray] = useState([0, 0]);
    const [explain, setExplain] = useState("");
    const [image, setImage] = useState([]);

    const onImage = (id, e) => {


        //    console.log(id)

        const nowSelectImageList = e.target.files;

        const nowImageURLList = [];

        if (nowSelectImageList.length < 1) {
            return;
        }

        for (let i = 0; i < 1; i++) {
            const nowImageUrl = URL.createObjectURL(nowSelectImageList[i]);
            nowImageURLList.push(nowImageUrl);
        }




        setContent(content.map(item => {
            if (item.id === id) {
                return { ...item, src: nowImageURLList[0], img: e.target.files[0] }
            } else {
                return item
            }

        }))

        setBitarray(bitarray.map((item, index) => {
            if (index === id) {
                return 1
            } else {
                return item
            }
        }
        ))

        console.log(content)

        console.log(bitarray)



    }

    const nextId = useRef(2);

    const styles = useStyles();





    const [content, setContent] = useState([
        {
            id: 0,
            content: "",
            src: "",
            img: ""
        },
        {
            id: 1,
            content: "",
            src: "",
            img: ""
        }
    ]);


    const [deadline, setDeadline] = useState(moment());

    const addContent = useCallback(() => {

        setContent([...content, { id: nextId.current, content: "", src: "", img: "" }]);
        setBitarray([...bitarray, 0]);

        console.log(bitarray)

        nextId.current += 1;

    }, [content, bitarray]);

    const removeContent = useCallback((e) => {

        setContent(content.filter(item => item.id !== parseInt(e)))
        setBitarray([...bitarray.filter((item, index) => index !== parseInt(e))])
        console.log(bitarray)
    }, [content, bitarray])

    const removeImg = (e) => {

        setContent(content.map(item => {
            if (item.id === parseInt(e)) {
                return { ...item, src: "", img: "" }
            } else {
                return item
            }
        }))

        setBitarray(bitarray.map((item, index) => {
            if (index === parseInt(e)) {
                return 0
            } else {
                return item
            }
        }
        ))

        console.log(content)
        console.log(bitarray)
    }

    const onContent = useCallback((e) => {
        const { name, value } = e.target;

        console.log(name)
        setContent(content.map(item => {
            if (item.id === parseInt(name)) {
                return { ...item, content: value }
            } else {
                return item
            }
        }));
    }, [content])

    const onSubmit = async (e) => {
        e.preventDefault();
        if (title === "") {
            toast.warning("제목을 입력해주세요")
            return;
        }
        const formData = new FormData();

        for (let i = 0; i < content.length; i++) {

            if (content[i].content === "") {
                toast.warning("내용을 입력해주세요")
                return;
            }

            if (content[i].img !== "") {
                formData.append("image", content[i].img);

            }

        }

        try {



            const { userID, name, level } = await personalinfo();


            formData.append("with_image", formData.has("image"));
            formData.append("title", title);
            formData.append("polls", JSON.stringify(content));
            formData.append("bitarray", JSON.stringify(bitarray));
            formData.append("author_userid", userID);
            formData.append("author", name);
            formData.append("author_lvl", level);
            formData.append("multi_response", multiResponse);
            formData.append("deadline", deadline);
            formData.append("content", explain);
            formData.append("date", moment().format("YYYY-MM-DDTHH:mm:ss.000+00:00"));


            postGeneral(formData).then(res => {
                if (res.result === 1) {
                    toast.success("성공적으로 작성되었습니다")
                    setTitle("")
                    setMultiResponse(false)
                    setExplain("")
                    setDeadline(moment())
                    setContent([{ id: 0, content: "", src: "", img: "" }, { id: 1, content: "", src: "", img: "" }])
                    setBitarray([0, 0])
                    setTimeout(() => {
                        history.push("/general")
                    }, 1000)

                } else {
                    toast.error("오류가 발생했습니다")
                }
            }
            ).catch(err => {
                console.log(err)
            })
        } catch (err) {
            console.log(err)
        }


    }

    const inputContent = content.map((item, index) => {

        return (
            <>
                <div className={styles.contentBox} key={index}>

                    {
                        item.src !== "" ?
                            <>
                                <Badge onClick={() => removeImg(item.id)} badgeContent="X" color="secondary" variant="standard" className={styles.badge} />

                                <img src={item.src} alt="123" className={styles.img} />

                            </>
                            :
                            <>
                                <input
                                    className={styles.display}
                                    onChange={(e) => onImage(item.id, e)}
                                    accept="image/*" id={item.id} type="file"
                                />

                                <label htmlFor={item.id} >
                                    <IconButton className={styles.imgIcon} aria-label="upload picture" component="span">
                                        <ImageSearchOutlinedIcon fontSize="large" />
                                    </IconButton>
                                </label>
                            </>
                    }
                    <Input type="text" className={styles.inputSelection} required name={item.id} value={item.content} onChange={(e) => onContent(e)} />
                    {index > 1 ?
                        <IconButton className={styles.imgIcon} onClick={() => removeContent(item.id)} >
                            <RemoveCircleOutlineIcon fontSize="large" />
                        </IconButton> : null}
                </div>
                <br />
            </>
        )

    })

    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <span className={styles.title}>질문 제목 <em className={styles.star}>*</em></span>
                <Input type="text" className={styles.input} required value={title} onChange={(e) => { setTitle(e.target.value) }} />
            </div>

            <div className={styles.selection}>
                <div>
                    <div className={styles.selectionTitle}>항목 입력<em className={styles.star}>*</em></div>
                </div>
                <div className={styles.selectionContent}>

                    {inputContent}

                    <IconButton onClick={addContent} style={{ marginLeft: "45%" }}>
                        <AddCircleOutlineIcon fontSize="large" />
                    </IconButton>

                </div>
            </div>

            <br />
            <br />
            <div className={styles.selection}>
                <div>
                    <div className={styles.selectionTitle}>투표 옵션</div>
                </div>
                <div className={styles.selectionContent}>

                    <div>
                        <Checkbox onClick={(e) => {
                            // console.log(e.target.checked)
                            setMultiResponse(e.target.checked)
                        }} /><span>복수 응답</span>
                    </div>
                    <div>
                        <Checkbox onClick={(e) => {
                            if (e.target.checked) {
                                setDeadline(moment().add(14, "days").format("YYYY-MM-DDTHH:mm:ss.000+00:00"))
                            } else {
                                setDeadline(moment().format("YYYY-MM-DDTHH:mm:ss.000+00:00"))
                            }
                        }} /><span>투표 마감일(최대 2주)</span>
                    </div>
                    <LocalizationProvider dateAdapter={AdapterDateFns} >
                        <MobileDateTimePicker
                            value={deadline}
                            onChange={(e) => {
                                // console.log(e)
                                setDeadline(moment(e).format("YYYY-MM-DDTHH:mm:ss.000+00:00"))
                            }}
                            disablePast
                            label="마감 기한"
                            maxDate={moment().add(14, 'days')}
                            inputFormat="       yyyy년  MM월  DD일   h시 mm분 a"

                            mask="   ___년 __월 __일  _시 __분 m"
                            renderInput={(params) => <TextField {...params} className={styles.textInput} />}
                        />
                    </LocalizationProvider>


                </div>

            </div>
            <div className={styles.box}>
                <span className={styles.title}>투표 내용 <em className={styles.star}>*</em></span>

                <TextField multiline minRows={10} className={styles.explain} value={explain} onChange={(e) => { setExplain(e.target.value) }} />

            </div>

            <div style={{ width: "100%", height: "50px" }}>
                <Button
                    onClick={onSubmit}
                    className={styles.button}
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<CloudUploadIcon />}>
                    업로드
                </Button>
                <Button
                    className={styles.button}
                    variant="contained"
                    color="default"
                    size="large"
                    startIcon={<SaveIcon />}>
                    임시 저장
                </Button>
            </div>
        </div >

    );
}


export default CreateGeneral;